import {
  LOAD_METADATA_SUCCESS,
  SET_CATEGORY_GROUPS,
  SET_LANGUAGE,
} from './constants';

export const initialState = {
  categories: null,
  language: null,
  categoryGroups: {},
};

function metadataProvider(state = initialState, action) {
  switch (action.type) {
    case LOAD_METADATA_SUCCESS:
      return { ...state, ...action.payload };
    case SET_LANGUAGE:
      return {
        ...state,
        language: action.payload.language,
      };
    case SET_CATEGORY_GROUPS:
      return {
        ...state,
        categoryGroups: action.payload.categoryGroups,
      };
    default:
      return state;
  }
}

export default metadataProvider;
